<template>
    <settings-editor-base
        v-bind:label="label"
        v-bind:input-container-column-size="4"
        v-bind:label-container-column-size="8"
    >
        <template v-slot="{inputId}">
            <input
                    type="checkbox"
                    v-bind:id="inputId"
                    v-model="model"
            >
        </template>
    </settings-editor-base>
</template>

<script>
    import SettingsEditorBase from "./SettingsEditorBase.vue";

    export default {
        name: "settings-toggle",
        components: {SettingsEditorBase},
        computed: {
            model: {
                get(){
                    return this.value;
                },
                set(value){
                    this.$emit('input', value);
                }
            }
        },
        props: {
            label: {
                type: String,
                required: true
            },
            value: Boolean
        }
    };
</script>
